import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AccountService } from '../../../services/account.service';
import { WatchAccountService } from '../../../services/watch-account.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'modal-create-label',
  template: require('./modal-create-label.component.pug'),
  styles: [require('./modal-create-label.component.css').toString()],
})
export class ModalCreateLabelComponent implements OnInit {
  name: string = null;
  icon = 'fal fa-user-edit';
  sentiment: number = 0;
  public reason: Subject<any>;

  iconList = [
    'fal fa-user-edit',
    'fal fa-database',
    'fal fa-info',
    'fal fa-flask',
    'fal fa-bolt',
    'fal fa-comment-alt-smile',
  ];

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private accountService: AccountService,
    private watch: WatchAccountService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.reason = new Subject();
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.bsModalRef.hide();
  }

  // -------------------------------------------------------------------
  setIcon(icon) {
    this.icon = icon;
  }

  // -------------------------------------------------------------------
  setSentiment(sentiment) {
    this.sentiment = sentiment;
  }

  // -------------------------------------------------------------------
  iconClass(icon) {
    let newClass = {};
    newClass[icon] = true;
    return newClass;
  }

  // -------------------------------------------------------------------
  save(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    let acc_id = this.watch.accountId().getValue();
  }
}
